import fitvids from 'fitvids'

/**
 * Fit videos
 */

fitvids()
